import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/modules/ArticleDetailModule/ArticleDetailModule.tsx");
